import Layout from '@/layout';
import ExchangeShopRouter from '../../../cloudserver/router/exchangeShop';

export default ExchangeShopRouter(Layout, 'pc');
